"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AssetRegistry {
    constructor() {
        this.registry = {};
    }
    register(key, asset) {
        this.registry[key] = asset;
    }
    get(key) {
        return this.registry[key];
    }
}
exports.AssetRegistry = AssetRegistry;
exports.default = new AssetRegistry();



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-asset-provider/core/AssetRegistry.ts